import 'react-native-url-polyfill/auto'
import { BuyerHomeView } from '~/components/home/BuyerHomeView'
import { RealtorHomeView } from '~/components/home/RealtorHomeView'
import ScreenView from '~/components/layout/ScreenView'
import { LoadingView } from '~/components/LoadingView'
import { useUserProfile } from '~/data/user/userProfile'

function AppIndex() {
  const { data: profile, isLoading: isLoadingProfile } = useUserProfile()
  const roles = profile?.roles
  const mainRole = roles?.[0]

  return (
    <ScreenView innerClassName="pt-0">
      {isLoadingProfile ? (
        <LoadingView />
      ) : mainRole === 'realtor' ? (
        <RealtorHomeView />
      ) : (
        <BuyerHomeView />
      )}
    </ScreenView>
  )
}

export default AppIndex
